/**
* Cards Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Cards Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'cards-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      slickCards();

      $( window ).on( 'resize', function() {
        slickCards();
      } );

      function slickCards() {
        $( '.cards-slider' ).each( function() {
          const $progressBarLabel = $( this ).find( '.slider__label' );
          const $progressBar = $( this ).find( '.progress-bar' );

          $( this ).find( '.cards-slider_slider' ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
            let calc = ( ( nextSlide ) / ( slick.slideCount-1 ) ) * 100;
            if ( calc === 0 ) {
              calc = 5;
            }
            $progressBar
                .css( 'background-size', calc + '% 100%' )
                .attr( 'aria-valuenow', calc );
            $progressBarLabel.text( calc + '% completed' );
          } );

          if ( $( this ).find( '.slide' ).length > 3 ) {
            $( this ).find( '.cards-slider_slider' ).slick( {
              dots: false,
              arrows: true,
              prevArrow: $( this ).find( '.prev-slide' )[0],
              nextArrow: $( this ).find( '.next-slide' )[0],
              slidesToShow: 3,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
            } );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'cards-slider', COMPONENT );
} )( app );
